export class QrPaymentShipmentModel {
  transactionHistoryId: number;
  billNumber: string;
  data: string;
  qrAccount: string;
  bankName: string;
  accountNumber: string;
  accountHolderName: string;
  amount: number;
  expiredDate: string;
  expireInMinute: number;
}
